import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const homeEssentialsInsiderStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#F5F4E9]',
  COMMONS_APPBAR_TEXT: 'text-black',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-black',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-black',
  COMMONS_FOOTER_BG: 'bg-[#F5F4E9]',
  COMMONS_FOOTER_TEXT: 'text-black',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-black',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#FF4D3C] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#F5F4E9]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#FF4D3C]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#FF4D3C] text-black hover:bg-[#FF4D3C]',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#9BADBF]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#0D2818]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#F5F4E9]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-black',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#F5F4E9]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#0D2818]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#FF4D3B] text-black [&>svg>path]:stroke-black [&>svg>g>path]:stroke-black [&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#FF4D3B] text-[#FF4D3B] [&>svg>path]:stroke-[#FF4D3B] [&>svg>g>path]:stroke-[#FF4D3B] [&>svg>path]:fill-[#FF4D3B] [&>svg>g>path]:fill-[#FF4D3B]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#FF4D3B]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-black [&>svg>g>path]:stroke-black',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#F5F4E9]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F5F4E9]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#0D2818]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F5F4E9]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#F5F4E9] [&>.explore-icon-fill]:!fill-[#F5F4E9] [&>g>.explore-icon-fill]:!fill-[#F5F4E9]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F5F4E9] [&>.vector-top>path]:fill-[#F5F4E9] [&>.vector-bottom>path]:fill-[#F5F4E9]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#9AADBF]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-black',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FEE2E2]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#44403C]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#9AADBF]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#9AADBF]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-black',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#0D2818]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#0D2818]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#FEBAB3]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#3B82F6]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: ' stroke-[#3B82F6]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#FEBAB3]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#0D2818]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#FF4D3B] text-black [&>svg>path]:stroke-black [&>svg>g>path]:stroke-black [&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#FF4D3B] text-[#FF4D3B] [&>svg>path]:stroke-[#FF4D3B] [&>svg>g>path]:stroke-[#FF4D3B] [&>svg>path]:fill-[#FF4D3B] [&>svg>g>path]:fill-[#FF4D3B]',
  LISTPAGE_BUTTON_LINK: 'text-[#FF4D3B]',
  LISTPAGE_ANCHOR_LINK: 'text-[#FF4D3B]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#FF4D3B]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-black [&>svg>g>path]:stroke-black',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#FF4D3B]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#FF4D3B]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#FF4D3B] text-black [&>svg>path]:stroke-black [&>svg>g>path]:stroke-black [&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#FF4D3B] text-[#FF4D3B] [&>svg>path]:stroke-[#FF4D3B] [&>svg>g>path]:stroke-[#FF4D3B] [&>svg>path]:fill-[#FF4D3B] [&>svg>g>path]:fill-[#FF4D3B]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#FF4D3B]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#FF4D3B]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-black [&>svg>g>path]:stroke-black',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#FF4D3B]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#FF4D3B]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'border-[#FECACA]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#FF4D3B]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F5F4E9] [&>.vector-top>path]:fill-[#EBEAD7] [&>.vector-bottom>path]:fill-[#EBEAD7]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-blue-100 [&>circle]:stroke-blue-100 [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#FFE4E1] data-[focus]:text-black',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#FEBAB3]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#0D2818]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container-new-layout',
}
